/* eslint-disable camelcase */
import type { StoreObject } from '@apollo/client/cache';
import type { DegreePlan_PersonalizedSegmentCourse as PersonalizedSegmentCourse } from '__generated__/graphql-types';

import type { QuestionBankSummariesV1 } from 'bundles/naptimejs/resources/__generated__/QuestionBankSummariesV1';
import type { EntityKeyFieldsMap } from 'bundles/page/lib/network/typePolicies';

// Is your GraphQL entity not caching correctly? Read below!
//
// Perhaps Apollo cannot identify your entity because it lacks an `id` field, and therefore it cannot cache it (or it
// incorrectly overwrites it in the cache). You can specify here a list of field names for your entity's type name to
// tell Apollo what your entity's identifier is. These keys will be used to normalize it in the cache. You MUST include
// these fields in your query, otherwise Apollo will throw an error.
//
// Perhaps you have an key conflict, where you have a [__typename, id] combination that is not unique (even though it
// should be). You can specify here a `false` for your entity's type name to turn off cache normalization for your type.
//
// Perhaps you have a namespace object. You can specify here a `[]` for your entity's type name to turn on namespace
// handling.

const EntityKeyFields: EntityKeyFieldsMap = {
  GroupGrading_Item: ['itemId'],
  GroupGrading_Group: ['groupId'],
  RestQuizQuestionDataElement: ['id'],
  RestQuizQuestionDataElementResult: false,
  DiscoveryCollections_cursoredProductCollections: false,
  Submission_RubricOption: false,
  Submission_GradedOption: false,
  Submission_GradedMultipleChoiceFillableBlank: false,
  Submission_MultipleChoiceFillableBlankResponse: false,
  Submission_MultipleChoiceOption: false,
  Submission_MultipleChoiceFillableBlank: false,
  AssignmentPresentations_ReviewPartSchemaDetailsOptionsReviewSchema: false,
  LearnerPlan_PlannedSegmentCourse: false,
  DegreePlan_LearnerProgress: false,
  DegreePlan_Course: ['courseCode'],
  LearnerPlan_TermPlan: ['estimatedTermId'],
  LearnerPlan_LearnerPlanResult: [],
  DegreePlan_PersonalizedSegmentCourse: (object: Readonly<StoreObject>) => {
    return `DegreePlan_PersonalizedSegmentCourse: ${(object as PersonalizedSegmentCourse).segmentCourse.id}`;
  },
  NaptimeQuestionBankSummariesV1: (object: Readonly<StoreObject>) => {
    const questionBankSummariesV1 = object as {} as QuestionBankSummariesV1;
    return `NaptimeQuestionBankSummariesV1:${
      questionBankSummariesV1?.embedSourceCourseId
        ? questionBankSummariesV1?.metadata?.publishedId
        : questionBankSummariesV1?.id
    }`;
  },
};

export default EntityKeyFields;
